module.exports = __webpack_public_path__ + "img/Jump Casting76.13d402e1.jpg";